module.exports = __webpack_public_path__ + "static/img/14000717.a22fa741.png";